import { render, staticRenderFns } from "./OfflineExam.vue?vue&type=template&id=4d1fb3c5"
import script from "./OfflineExam.vue?vue&type=script&lang=js"
export * from "./OfflineExam.vue?vue&type=script&lang=js"
import style0 from "./OfflineExam.vue?vue&type=style&index=0&id=4d1fb3c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports